$(function() {
	$('.collapsible [data-close]').on('click', function (e) {
	    $(this).closest('li').find('.collapsible-header').trigger('click');
	});
})


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/accordion/index.js
 **/